// import React, { useState, useEffect, useContext } from "react";
// import { Col, Container, Row } from "react-bootstrap";

// import { useNavigate, useLocation } from "react-router-dom";
// import { trackEvent, trackPageView } from "../utils/tracking";

// // import "./FactSheetDisclosures.css";

// // Tab-content components — one per data point from the client requirement sheet
// import MajorRiskFactors from "./Majorriskfactors/Majorriskfactors";
// import VideoExplainer from "./Videoexplainer/Videoexplainer";
// import QRCodeSID from "./Qrcodesid/Qrcodesid";
// import PortfolioData from "./Portfoliodata/Portfoliodata";
// import CalculationMethodology from "./Calculationmethodology/Calculationmethodology";
// import DetailedRiskFactors from "./Detailedriskfactors/Detailedriskfactors ";
// import GrievanceRedressal from "./Grievanceredressal/Grievanceredressal";
// import InvestorServices from "./Investorservices/Investorservices";
// import {
//   DecryptAESdata,
//   GetPostMethodData,
// } from "../../provider/ServiceProvider";
// import URLstateContext from "../../provider/CommonContext";

// // Sr. no. from the requirement sheet is kept as a comment next to each tab
// // so the mapping back to the client doc stays obvious.
// const TABS = [
//   { key: "Major Risk Factors", Component: MajorRiskFactors }, // Sr 1
//   { key: "Calculation Methodology", Component: CalculationMethodology }, // Sr 2
//   { key: "Detailed Risk Factors", Component: DetailedRiskFactors }, // Sr 3
//   { key: "Grievance Redressal", Component: GrievanceRedressal }, // Sr 4
//   { key: "Video Explainer", Component: VideoExplainer }, // Sr 5
//   { key: "QR Code to SID", Component: QRCodeSID }, // Sr 6
//   { key: "Investor Services", Component: InvestorServices }, // Sr 7
//   { key: "Portfolio Data", Component: PortfolioData }, // Sr 8
// ];

// function FactSheetDisclosures() {
//   useEffect(() => {
//     trackPageView(
//       "https://www.jmfinancialmf.com/FactSheetDisclosures",
//       "jmf_factsheet-disclosures_landing",
//     );

//     trackEvent({
//       category: "Static Page",
//       action: "FactSheetDisclosures Page Loaded",
//       label: "jmf_factsheet-disclosures_landing",
//       value: 1,
//     });
//   }, []);

//   const [loading, setLoading] = useState(true);
//   const [activeTab, setActiveTab] = useState(TABS[0].key);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [factsheetData, setFactsheetData] = useState([]);
//   const { BaseURL } = useContext(URLstateContext);

//   useEffect(() => {
//     setLoading(true);

//     GetPostMethodData(BaseURL + "GetFactsheetDisclosures", {
//       factsheetId: null,
//     })
//       .then((data) => {
//         if (data?.data?.length > 0) {
//           const decrypted = DecryptAESdata(data.data);

//           console.log("Factsheet Disclosures:", decrypted);

//           setFactsheetData(decrypted);
//         } else {
//           setFactsheetData([]);
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching Factsheet Disclosures:", error);

//         setFactsheetData([]);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [BaseURL]);

//   useEffect(() => {
//     const pathname = location.pathname;
//     const tabName = pathname
//       .substring(pathname.lastIndexOf("/") + 1)
//       .replace(/-/g, " ");

//     if (tabNameIsValid(tabName)) {
//       setActiveTab(tabName);
//     } else {
//       setActiveTab(TABS[0].key);
//     }
//   }, [location.pathname]);

//   const tabNameIsValid = (tabName) => TABS.some((tab) => tab.key === tabName);

//   // const handleTabClick = (tabName) => {
//   //   setActiveTab(tabName);
//   //   navigate(`/Factsheet-disclosures/${tabName.replace(/\s+/g, "-")}`);
//   // };

//   const handleTabClick = (tab) => {
//     setActiveTab(tab.key);

//     if (tab.dynamic) {
//       const selectedData = factsheetData.find(
//         (item) => item.drptype === tab.key,
//       );

//       if (selectedData) {
//         navigate(`/Factsheet-disclosures/${selectedData.factsheetId}`);
//       }
//     } else {
//       // Static tab
//       navigate(`/Factsheet-disclosures/${tab.key.replace(/\s+/g, "-")}`);
//     }
//   };
//   // const renderTabContent = () => {
//   //   const activeTabConfig = TABS.find((tab) => tab.key === activeTab);
//   //   if (!activeTabConfig) return null;
//   //   const { Component } = activeTabConfig;
//   //   return <Component />;
//   // };

// const renderTabContent = () => {
//   const activeTabConfig = TABS.find(
//     (tab) => tab.key === activeTab
//   );

//   if (!activeTabConfig) {
//     return null;
//   }

//   const {
//     Component,
//     dynamic,
//   } = activeTabConfig;

//   // ==========================================
//   // STATIC COMPONENT
//   // ==========================================

//   if (!dynamic) {
//     return <Component />;
//   }

//   // ==========================================
//   // DYNAMIC DATA
//   // ==========================================

//   const selectedData = factsheetData.filter(
//     (item) =>
//       item.drptype === activeTab
//   );

//   if (selectedData.length === 0) {
//     return (
//       <div>
//         No data available for {activeTab}
//       </div>
//     );
//   }

//   return (
//     <Component
//       data={selectedData}
//     />
//   );
// };


//   return (
//     <>
//       <style>
//         {`
//           .factsheet-tabs-sticky {
//             position: sticky;
//             top: 20px;
//             align-self: flex-start;
//             height: fit-content;
//           }
//         `}
//       </style>

//       <main>
//         <section className="trustee-sc product-main">
//           <Container>
//             <Row>
//               <Col sm={12}>
//                 <div className="section-header">
//                   <h1>Factsheet Disclosures</h1>
//                 </div>
//               </Col>
//               <Col sm={12}>
//                 <Row className="padd15top">
//                   <Col
//                     sm={4}
//                     style={{
//                       padding: "10px",
//                       position: "sticky",
//                       top: "20px",
//                       alignSelf: "flex-start",
//                       height: "fit-content",
//                     }}
//                     className="factsheet-tabs-col factsheet-tabs-sticky"
//                   >
//                     <div role="tablist" aria-label="FactSheet Disclosures Tabs">
//                       {/* {TABS.map(({ key }) => (
//                       <div
//                         key={key}
//                         className={
//                           activeTab === key
//                             ? "aboutusactive"
//                             : "aboutusinactive"
//                         }
//                       >
//                         <button
//                           role="tab"
//                           type="button"
//                           aria-selected={activeTab === key}
//                           className={
//                             activeTab === key
//                               ? "aboutusactivetext cursorpointer"
//                               : "cursorpointer"
//                           }
//                           onClick={() => handleTabClick(key)}
//                         >
//                           {key}
//                         </button>
//                       </div>
//                     ))} */}
//                       {TABS.map((tab) => (
//                         <div
//                           key={tab.key}
//                           className={
//                             activeTab === tab.key
//                               ? "aboutusactive"
//                               : "aboutusinactive"
//                           }
//                         >
//                           <button
//                             role="tab"
//                             type="button"
//                             aria-selected={activeTab === tab.key}
//                             className={
//                               activeTab === tab.key
//                                 ? "aboutusactivetext cursorpointer"
//                                 : "cursorpointer"
//                             }
//                             onClick={() => handleTabClick(tab)}
//                           >
//                             {tab.key}
//                           </button>
//                         </div>
//                       ))}
//                     </div>
//                   </Col>
//                   <Col sm={8}>{renderTabContent()}</Col>
//                 </Row>
//               </Col>
//             </Row>
//           </Container>
//         </section>
//       </main>
//     </>
//   );
// }

// export default FactSheetDisclosures;



import React, { useState, useEffect, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { trackEvent, trackPageView } from "../utils/tracking";

import MajorRiskFactors from "./Majorriskfactors/Majorriskfactors";
import VideoExplainer from "./Videoexplainer/Videoexplainer";
import QRCodeSID from "./Qrcodesid/Qrcodesid";
import PortfolioData from "./Portfoliodata/Portfoliodata";
import CalculationMethodology from "./Calculationmethodology/Calculationmethodology";
import DetailedRiskFactors from "./Detailedriskfactors/Detailedriskfactors "

import GrievanceRedressal from "./Grievanceredressal/Grievanceredressal";
import InvestorServices from "./Investorservices/Investorservices";

import {
  DecryptAESdata,
  GetPostMethodData,
} from "../../provider/ServiceProvider";
import URLstateContext from "../../provider/CommonContext";

const TABS = [
  { key: "Portfolio Data", label: "Portfolio Data", Component: PortfolioData, isDynamic: true },
  { key: "Video Explainer", label: "Video Explainer", Component: VideoExplainer, isDynamic: true },
  // { key: "Major Risk Factors", label: "Major Risk Factors", Component: MajorRiskFactors, isDynamic: true },
  {
    key: "MethodologyCalculation",           
    label: "Methodology/Calculation",        
    Component: CalculationMethodology,
    isDynamic: true,
  },
  { key: "Detailed Risk Factors", label: "Detailed Risk Factors", Component: DetailedRiskFactors, isDynamic: true },
  { key: "QR Code to SID", label: "QR Code to SID", Component: QRCodeSID, isDynamic: false },
  { key: "Annexure", label: "Annexure", Component: GrievanceRedressal, isDynamic: true },
  { key: "Investor Services", label: "Investor Services", Component: InvestorServices, isDynamic: false },
];

const toSlug = (key) =>
  encodeURIComponent(key.replace(/\s+/g, "-"));

const fromSlug = (slug) => {
  try {
    return decodeURIComponent(slug).replace(/-/g, " ");
  } catch {
    return slug.replace(/-/g, " ");
  }
};

function FactSheetDisclosures() {
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(TABS[0].key);
  const [factsheetData, setFactsheetData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { BaseURL } = useContext(URLstateContext);

  // Tracking
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/FactSheetDisclosures",
      "jmf_factsheet-disclosures_landing"
    );

    trackEvent({
      category: "Static Page",
      action: "FactSheetDisclosures Page Loaded",
      label: "jmf_factsheet-disclosures_landing",
      value: 1,
    });
  }, []);

  // Fetch all factsheet disclosures once
  useEffect(() => {
    setLoading(true);

    GetPostMethodData(BaseURL + "GetFactsheetDisclosures", {
      factsheetId: null,
    })
      .then((data) => {
        if (data?.data?.length > 0) {
          const decrypted = DecryptAESdata(data.data);
          console.log("Factsheet Disclosures:", decrypted);
          setFactsheetData(Array.isArray(decrypted) ? decrypted : []);
        } else {
          setFactsheetData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching Factsheet Disclosures:", error);
        setFactsheetData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [BaseURL]);

  // Sync active tab from URL
  
  // useEffect(() => {
  //   const pathname = location.pathname;
  //   const tabName = pathname
  //     .substring(pathname.lastIndexOf("/") + 1)
  //     .replace(/-/g, " ");

  //   const isValid = TABS.some((tab) => tab.key === tabName);
  //   setActiveTab(isValid ? tabName : TABS[0].key);
  // }, [location.pathname]);

  useEffect(() => {
    const pathname = location.pathname;
    const rawSlug = pathname.substring(pathname.lastIndexOf("/") + 1);
    const tabName = fromSlug(rawSlug);

    const isValid = TABS.some((tab) => tab.key === tabName);
    setActiveTab(isValid ? tabName : TABS[0].key);
  }, [location.pathname]);


  const handleTabClick = (tab) => {
    setActiveTab(tab.key);
    // navigate(`/Factsheet-disclosures/${tab.key.replace(/\s+/g, "-")}`);
    
  };

  const renderTabContent = () => {
    const activeTabConfig = TABS.find((tab) => tab.key === activeTab);
    if (!activeTabConfig) return null;

    const { Component, isDynamic } = activeTabConfig;

    // Static tabs – no props needed
    if (!isDynamic) {
      return <Component />;
    }

    // Dynamic tabs – filter data by drptype
    const selectedData = factsheetData.filter(
      (item) => item.drptype === activeTab && item.IsActive === 1
    );

    return (
      <Component
        data={selectedData}
        loading={loading}
        BaseURL={BaseURL}
      />
    );
  };

  return (
    <>
      <style>
        {`
          .factsheet-tabs-sticky {
            position: sticky;
            top: 20px;
            align-self: flex-start;
            height: fit-content;
          }
        `}
      </style>

      <main>
        <section className="trustee-sc product-main">
          <Container>
            <Row>
              <Col sm={12}>
                <div className="section-header">
                  <h1>Factsheet Disclosures</h1>
                </div>
              </Col>

              <Col sm={12}>
                <Row className="padd15top">
                  <Col
                    sm={4}
                    style={{
                      padding: "10px",
                      position: "sticky",
                      top: "20px",
                      alignSelf: "flex-start",
                      height: "fit-content",
                    }}
                    className="factsheet-tabs-col factsheet-tabs-sticky"
                  >
                    <div role="tablist" aria-label="FactSheet Disclosures Tabs">
                      {TABS.map((tab) => (
                        <div
                          key={tab.key}
                          className={
                            activeTab === tab.key
                              ? "aboutusactive"
                              : "aboutusinactive"
                          }
                        >
                          <button
                            role="tab"
                            type="button"
                            aria-selected={activeTab === tab.key}
                            className={
                              activeTab === tab.key
                                ? "aboutusactivetext cursorpointer"
                                : "cursorpointer"
                            }
                            onClick={() => handleTabClick(tab)}
                          >
                            {tab.label}
                          </button>
                        </div>
                      ))}
                    </div>
                  </Col>

                  <Col sm={8}>{renderTabContent()}</Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
    </>
  );
}

export default FactSheetDisclosures;